import { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import {
    apiGetMembers,
} from '../../Api/Profile/Profile';
import { serilizeGetMembers } from '../../Api/Profile/serilizeProfile';
import { apiSendResiliationRequest, getContractCancellationContracts } from '../../Api/Resiliation/Resiliation';
import { Button, DatePicker, Text } from '../../Atoms';
import { API_URL } from '../../Config/Config';
import { Input } from '../../Molecules';
import { isNumber } from '../../Validation';
import TemplateResiliationSuccess from './TemplateResiliationSuccess';

class Resiliation extends Component {
    constructor(props) {
        super(props);
        const canonical = document.querySelector('link[rel=canonical]');
        this.url = canonical ? canonical.href : document.location.href;
        let currentDateMax = new Date();
        let currentDateMin = new Date();
        currentDateMax.setFullYear(currentDateMax.getFullYear() - 18)
        currentDateMin.setFullYear(currentDateMin.getFullYear() - 100)
        this.state = {
            confirmState: false,
            check: false,
            validate: false,
            successSend: false,
            showCalendar: false,
            displayedMotif: "",
            benificiaireList: null,
            maxBirthdayDate: new Date(currentDateMax),
            minBirthdayDate: new Date(currentDateMin),
            contracts: null,
            errorsResiliation: [],
            errorsTextResiliation: [],
            motifsDisplayLabel: ["Résiliation à échéance", "Résiliation infra annuelle (RIA)", "Changement de situation", "Augmentation tarifaire", "Dècès de l'assuré", "Autre"],
            cancellationContractsMotifs: [{ value: "Résiliation à échéance", label: <span dangerouslySetInnerHTML={{ __html: "<strong>Résiliation à échéance</strong> </br> Votre demande doit être adressée au moins 2 mois avant la date d'échéance de votre contrat" }} /> },
            { value: "Résiliation infra annuelle (RIA)", label: <span dangerouslySetInnerHTML={{ __html: "<strong>Résiliation infra annuelle (RIA)</strong> </br> La résiliation prendra effet 1 mois après réception de votre demande." }} /> },
            { value: "Changement de situtation", label: <span dangerouslySetInnerHTML={{ __html: "<strong>Changement de situtation</strong> </br> Votre demande doit être adressée dans les 3 mois suivant la date de l'évènement à l'origine de votre changement de situation. La résiliation prendra effet 1 mois après réception de votre demande." }} /> },
            { value: "Augmentation tarifaire", label: <span dangerouslySetInnerHTML={{ __html: "<strong>Augmentation tarifaire</strong> </br> Votre demande doit être adressée au maximum 30 jours après la date de réception de votre échéancier de renouvellement" }} /> },
            { value: "Décès de l’assuré", label: <span dangerouslySetInnerHTML={{ __html: "<strong>Décès de l’assuré</strong> </br>A la suite de votre demande, un acte de décès vous sera demandé." }} /> },
            { value: "Autre", label: <span dangerouslySetInnerHTML={{ __html: "<strong>Autre</strong>" }} /> },
            ],
            data: {
                target: 'r',
                firstName: '',
                lastName: '',
                birthDate: '',
                cgrmCode: '',
                emailAddress: '',
                phone: '',
                postAddress: '',
                contractNumber: '',
                productFamily: '',
                cancellationReason: '',
                desiredCancellationDate: '',
                comment: '',
            },
            contractCancellationContracts: []
        };

    };

    getProfile = async () => {
        try {
            const res = await apiGetMembers(this.props.user.memberId);
            this.setState({
                benificiaireList: serilizeGetMembers(res, this.props.user.memberType),
                contracts: res.contracts
            });
            this.setState({
                data: {
                    firstName: res.firstName,
                    lastName: res.lastName,
                    birthDate: new Date(res.birthDate),
                    cgrmCode: res.cgrmContractingCode,
                    emailAddress: res.mailPhoneFax.emailAddress,
                    phone: res.mailPhoneFax.phone,
                    postAddress: `${res.postalAddress.cityAddress} ${res.postalAddress.postalCode ? res.postalAddress.postalCode : ''} ${res.postalAddress.city ? res.postalAddress.city : ''}`,
                    contractNumber: '',
                    productFamily: '',
                    cancellationReason: '',
                    desiredCancellationDate: '',
                    target: '',
                    comment: '',
                }
            })

            const action = {
                type: 'SET_PROFILE',
                value: {
                    profile: serilizeGetMembers(res, this.props.user.memberType)
                }
            };
            this.props.dispatch(action);
        } catch (err) {
            this.setState({
                benificiaireList: []
            });
        }
    };

    componentDidMount() {
        this.getProfile();
        this.getContracts();
    }

    getContracts = async () => {
        const response = await getContractCancellationContracts();
        if (response.status === 200) {
            this.setState({
                contractCancellationContracts: response.data.map((elem) => { return { label: `${elem.productName} - ${elem.contractNumber}`, value: elem.contractNumber } })
            });
        } else {
        }
    };
    openResiliationContract() {
        if (API_URL == "https://monespaceassure-api.spvie.com/api") {
            window.open("https://www.spvie.com/resiliation", '_blank').focus();
        } else {
            window.open("https://www-pprd.spvie.com/resiliation", '_blank').focus();
        }

    }

    enterConfirmState(value) {
        let nonRequiredFields = ["cgrmCode", "comment"]
        let erroredFields = []
        for (var key in this.state.data) {
            if (nonRequiredFields.indexOf(key) == -1) {
                if (this.state.data[key] == null || (typeof this.state.data[key] == "string" && this.state.data[key].trim() == "")) {
                    erroredFields.push(key)
                    this.state.errorsResiliation.push(key)
                }
            }
        }
        this.setState({ errorsResiliation: erroredFields })
        let erroredTextFields = []
        if (erroredFields.length == 0) {
            var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
            if (!this.state.data.emailAddress.match(validRegex)) {
                erroredTextFields.push('emailAddress')
            }
            if (this.state.data.phone.length < 10) {
                erroredTextFields.push('phone')
            }
            this.setState({ errorsTextResiliation: erroredTextFields })
            if (erroredTextFields.length == 0) {
                this.setState({ confirmState: value })
            }
        }
    };

    onClickOpenCalender = () => {
        this.setState({ showCalendar: true });
    };

    onHideCalender = () => {
        this.setState({ showCalendar: false });
    };

    onChange(value, key) {
        const aux = { ...this.state.data };
        switch (key) {
            // case 'hospitalisationDuration':
            // case 'cp':
            // case 'fax':
            //     if (isNumber(value) || !value) {
            //         aux[key] = value.trim();
            //     }
            //     break;
            case 'cgrmCode':
            case 'phone':
                if (
                    !value ||
                    (value.length == 1 && (value == '+' || isNumber(value.trim()))) ||
                    isNumber(value.trim().slice(1))
                ) {
                    aux[key] = value.trim();
                }
                break;


            case 'cancellationReason':
                let indexOfOptuion = this.state.cancellationContractsMotifs.map((elem) => elem.value).indexOf(value)
                if (indexOfOptuion > -1) {
                    this.setState({ displayedMotif: { value: this.state.motifsDisplayLabel[indexOfOptuion], label: this.state.motifsDisplayLabel[indexOfOptuion] } })
                }
                aux[key] = value;
                break;
            default:
                aux[key] = value;
                break;
        }
        this.setState({ data: aux });
    };
    sendResiliationForm = async () => {
        const res = await apiSendResiliationRequest(JSON.stringify(this.state.data));
        if (res) {
            this.setState({ successSend: true });
        }
        // this.props.history.push('/');
    }

    render() {
        return (
            <div className="template-scroll cartetp-container" style={{ paddingBottom: '75px' }}>
                {
                    !this.state.successSend &&
                    <div >
                        <div className="cartetp-header-container hospitalisation-title-container">
                            <Text text="Demande de resiliation" type="h4" />
                        </div>
                        <div className="resiliation-fomulaire-top-rubric">
                            <div className='mb-10'>Vous souhaitez formuler une demande de résiliation de votre contrat ? Nous vous invitons à compléter ce formulaire, nous reviendrons vers vous dans les meilleurs délais.</div>
                            <div className='mb-10'><span style={{ textDecoration: 'underline', fontWeight: 'bold' }}>Attention</span> : l'envoi de ce formulaire n'emporte pas la résiliation automatique.</div>
                            <div>Pour en savoir plus sur les conditions et les modalités de résiliation de votre contrat d'assurance, cliquez ci-dessous</div>
                            <div>
                                <Button
                                    text="Tout savoir sur la résiliation de votre contrat"
                                    className="btn-send mt-15"
                                    onClick={this.openResiliationContract}
                                />
                            </div>

                        </div>
                        <div className="container-hospitalisation">

                            <div className="container-hospitalisation-fomulaire">
                                <div className="resiliation-fomulaire-left-container">
                                    <div
                                        style={{ marginTop: window.innerWidth <= 768 ? '24px' : '0px' }}
                                    >
                                        <Select
                                            isDisabled={this.state.confirmState}
                                            styles={{
                                                control: (base, { isDisabled }) => ({
                                                    ...base,
                                                    height: "100%",
                                                    backgroundColor: !this.state.confirmState ? "#f8f8f8" : "#e9ecef",
                                                    border: "1px solid #c4c4c4"
                                                })
                                            }}
                                            className={`input-termination-formulaire ${this.state.errorsResiliation?.includes('target')
                                                ? 'input-document-error'
                                                : ''
                                                }`}
                                            classNamePrefix="select"
                                            name="color"
                                            onChange={(e) =>
                                                this.onChange(e.value, 'target')
                                            }
                                            options={[{ value: "Particulier", label: "Particulier" }, { value: "Travailleur non salarié", label: "Travailleur non salarié" }]}
                                            placeholder={<div style={{ color: '#c4c4c4' }}>Je suis</div>}
                                        />
                                        {this.state.errorsResiliation?.includes('target') ? (
                                            <Text
                                                className="default-error-msg"
                                                text="Ce champ est requis"
                                            />
                                        ) : null}
                                    </div>
                                    <div className="input-hospitalisation-container">
                                        <Input
                                            className={`input-termination-formulaire ${this.state.errorsResiliation?.includes('firstName')
                                                ? 'input-document-error'
                                                : ''
                                                }`}
                                            placeholder="Prénom"
                                            disabled={this.state.confirmState}
                                            value={this.state.data.firstName}
                                            onChange={(e) => this.onChange(e.target.value, 'firstName')}
                                        />
                                        {this.state.errorsResiliation?.includes('firstName') ? (
                                            <Text
                                                className="default-error-msg"
                                                text="Ce champ est requis"
                                            />
                                        ) : null}
                                    </div>

                                    <div className="input-hospitalisation-container">
                                        <Input
                                            disabled={this.state.confirmState}
                                            className={`input-termination-formulaire ${this.state.errorsResiliation?.includes('lastName')
                                                ? 'input-document-error'
                                                : ''
                                                }`}
                                            placeholder="Nom"
                                            value={this.state.data.lastName}
                                            onChange={(e) => this.onChange(e.target.value, 'lastName')}
                                        />
                                        {this.state.errorsResiliation?.includes('lastName') ? (
                                            <Text
                                                className="default-error-msg"
                                                text="Ce champ est requis"
                                            />
                                        ) : null}
                                    </div>
                                    <div className="input-hospitalisation-container input-hospitalisation-container-second">
                                        <DatePicker
                                            disabled={this.state.confirmState}
                                            renderIcon={false}
                                            placeholder='Date de naissance'
                                            minDate={this.state.minBirthdayDate}
                                            maxDate={this.state.maxBirthdayDate}
                                            // minDate={new Date("2020-12-17")}
                                            // maxDate={this.state.maxBirthdayDate}
                                            className={`date-picker-birth-date-beneficiaire-profile ${this.state.errorsResiliation?.includes('birthDate')
                                                ? 'input-document-error'
                                                : ''
                                                }`}
                                            selected={this.state.data.birthDate}
                                            onChange={e =>
                                                this.onChange(
                                                    e[0],
                                                    'birthDate',
                                                )
                                            }
                                        />
                                        {this.state.errorsResiliation?.includes('birthDate') ? (
                                            <Text
                                                className="default-error-msg"
                                                text="Ce champ est requis"
                                            />
                                        ) : null}
                                    </div>

                                </div>
                                <div className="resiliation-fomulaire-right-container">
                                    <div style={{ marginTop: window.innerWidth <= 768 ? '24px' : '0px' }}>
                                        <Input
                                            disabled={this.state.confirmState}
                                            className={`input-termination-formulaire`}
                                            placeholder="Numéro adherent"
                                            value={this.state.data.cgrmCode}
                                            onChange={(e) => this.onChange(e.target.value, 'cgrmCode')}
                                        />
                                    </div>
                                    <div
                                        className="input-hospitalisation-container"
                                    >
                                        <Input
                                            disabled={this.state.confirmState}
                                            className={`input-termination-formulaire ${this.state.errorsResiliation?.includes('emailAddress') || this.state.errorsTextResiliation?.includes('emailAddress')
                                                ? 'input-document-error'
                                                : ''
                                                }`}
                                            placeholder="Adresse mail"
                                            value={`${this.state.data.emailAddress}`}
                                            onChange={(e) => this.onChange(e.target.value, 'emailAddress')}
                                        />
                                        {this.state.errorsResiliation?.includes('emailAddress') ? (
                                            <Text
                                                className="default-error-msg"
                                                text="Ce champ est requis"
                                            />
                                        ) : null}
                                        {this.state.errorsTextResiliation?.includes('emailAddress') ? (
                                            <Text
                                                className="default-error-msg"
                                                text="Ce champ n'est pas conforme"
                                            />
                                        ) : null}
                                    </div>
                                    <div className="input-hospitalisation-container">
                                        <Input
                                            disabled={this.state.confirmState}
                                            className={`input-termination-formulaire ${this.state.errorsResiliation?.includes('phone') || this.state.errorsTextResiliation?.includes('phone')
                                                ? 'input-document-error'
                                                : ''
                                                }`}
                                            placeholder="Numéro de téléphone"
                                            value={this.state.data.phone}
                                            onChange={(e) => this.onChange(e.target.value, 'phone')}
                                        />
                                        {this.state.errorsResiliation?.includes('phone') ? (
                                            <Text
                                                className="default-error-msg"
                                                text="Ce champ est requis"
                                            />
                                        ) : null}
                                        {this.state.errorsTextResiliation?.includes('phone') ? (
                                            <Text
                                                className="default-error-msg"
                                                text="Ce champ n'est pas conforme"
                                            />
                                        ) : null}
                                    </div>
                                    <div className="input-hospitalisation-container">
                                        <Input
                                            disabled={this.state.confirmState}
                                            className={`input-termination-formulaire ${this.state.errorsResiliation?.includes('postAddress')
                                                ? 'input-document-error'
                                                : ''
                                                }`}
                                            placeholder="Adresse postale"
                                            value={this.state.data.postAddress}
                                            onChange={(e) => this.onChange(e.target.value, 'postAddress')}
                                        />
                                        {this.state.errorsResiliation?.includes('postAddress') ? (
                                            <Text
                                                className="default-error-msg"
                                                text="Ce champ est requis"
                                            />
                                        ) : null}
                                    </div>

                                </div>
                                <div className="resiliation-fomulaire-right-container">
                                    <div style={{ marginTop: window.innerWidth <= 768 ? '24px' : '0px' }}>
                                        <Select
                                            styles={{
                                                control: base => ({
                                                    ...base,
                                                    height: "100%",
                                                    backgroundColor: !this.state.confirmState ? "#f8f8f8" : "#e9ecef",
                                                    border: "1px solid #c4c4c4"
                                                })
                                            }}
                                            isDisabled={this.state.confirmState}
                                            className={`input-termination-formulaire  ${this.state.errorsResiliation?.includes('contractNumber')
                                                ? 'input-document-error'
                                                : ''
                                                }`}
                                            classNamePrefix="select"
                                            onChange={(e) =>
                                                this.onChange(e.value, 'contractNumber')
                                            }
                                            name="color"
                                            options={this.state.contractCancellationContracts}
                                            placeholder={<div style={{ color: '#c4c4c4' }}>Contrat</div>}
                                        />
                                        {this.state.errorsResiliation?.includes('contractNumber') ? (
                                            <Text
                                                className="default-error-msg"
                                                text="Ce champ est requis"
                                            />
                                        ) : null}
                                    </div>
                                    <div
                                        className="input-hospitalisation-container"
                                    >
                                        <Select
                                            isDisabled={this.state.confirmState}
                                            styles={{
                                                control: base => ({
                                                    ...base,
                                                    height: "100%",
                                                    backgroundColor: !this.state.confirmState ? "#f8f8f8" : "#e9ecef",
                                                    border: "1px solid #c4c4c4"
                                                })
                                            }}
                                            className={`input-termination-formulaire ${this.state.errorsResiliation?.includes('productFamily')
                                                ? 'input-document-error'
                                                : ''
                                                }`}
                                            classNamePrefix="select"
                                            name="color"
                                            onChange={(e) =>
                                                this.onChange(e.value, 'productFamily')
                                            }
                                            options={[{ value: "Santé", label: "Santé" }, { value: "Prévoyance", label: "Prévoyance" }]}
                                            placeholder={<div style={{ color: '#c4c4c4' }}>Risque couvert</div>}
                                        />
                                        {this.state.errorsResiliation?.includes('productFamily') ? (
                                            <Text
                                                className="default-error-msg"
                                                text="Ce champ est requis"
                                            />
                                        ) : null}
                                    </div>
                                    <div className="input-hospitalisation-container">
                                        <Select
                                            isDisabled={this.state.confirmState}
                                            styles={{
                                                control: base => ({
                                                    ...base,
                                                    height: "100%",
                                                    backgroundColor: !this.state.confirmState ? "#f8f8f8" : "#e9ecef",
                                                    border: "1px solid #c4c4c4"
                                                })
                                            }}
                                            className={`input-termination-formulaire ${this.state.errorsResiliation?.includes('cancellationReason')
                                                ? 'input-document-error'
                                                : ''
                                                }`}
                                            classNamePrefix="select"
                                            name="color"
                                            value={this.state.displayedMotif}
                                            onChange={(e) =>
                                                this.onChange(e.value, 'cancellationReason')
                                            }
                                            getOptionLabel={(option) => option.label}
                                            options={this.state.cancellationContractsMotifs}
                                            placeholder={<div style={{ color: '#c4c4c4' }}>Motif de résiliation</div>}
                                        />
                                        {this.state.errorsResiliation?.includes('cancellationReason') ? (
                                            <Text
                                                className="default-error-msg"
                                                text="Ce champ est requis"
                                            />
                                        ) : null}
                                    </div>
                                    <div className="input-hospitalisation-container input-hospitalisation-container-second">
                                        <DatePicker
                                            disabled={this.state.confirmState}
                                            renderIcon={false}
                                            placeholder='Date de résiliation souhaitée'
                                            minDate={new Date()}
                                            className={`date-picker-birth-date-beneficiaire-profile ${this.state.errorsResiliation?.includes('desiredCancellationDate')
                                                ? 'input-document-error'
                                                : ''
                                                }`}
                                            selected={this.state.data.desiredCancellationDate}
                                            onChange={e =>
                                                this.onChange(
                                                    e[0],
                                                    'desiredCancellationDate',
                                                )
                                            }
                                        />
                                        {this.state.errorsResiliation?.includes('desiredCancellationDate') ? (
                                            <Text
                                                className="default-error-msg"
                                                text="Ce champ est requis"
                                            />
                                        ) : null}
                                    </div>

                                </div>
                            </div>
                            {/* <Input
                                disabled={this.state.confirmState}
                                placeholder="Message"
                                className="actuality-input-text-container textarea-termination-formulaire"
                                classNameInputContainer="full-container"
                                style={{ marginTop: "15px" }}
                                as="textarea"
                                value={this.state.data.comment}
                                onChange={(e) => this.onChange(e.target.value, 'comment')}
                            /> */}
                            <textarea disabled={this.state.confirmState}
                                placeholder="Message"
                                className={`actuality-input-text-container ${this.state.confirmState ? "textarea-termination-formulaire-disabled" : "textarea-termination-formulaire"} `}
                                classNameInputContainer="full-container"
                                style={{ marginTop: "15px" }}
                                as="textarea"
                                value={this.state.data.comment}
                                onChange={(e) => this.onChange(e.target.value, 'comment')} />

                            {!this.state.confirmState &&
                                <div>
                                    <Button
                                        text="Suivant"
                                        className="btn-send mt-15"
                                        style={{ padding: "4px 25px" }}
                                        onClick={() => this.enterConfirmState(true)}
                                    />
                                </div>
                            }
                            {this.state.confirmState &&
                                <div style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignContent: "center",
                                    width: "100%",
                                    alignItems: "center"
                                }}
                                >
                                    <span onClick={() => this.enterConfirmState(false)} style={{ fontWeight: 700, textDecoration: 'underline', cursor: "pointer" }}>Modifier mes informations</span>
                                    <Button
                                        text="Confirmer ma demande de résiliation"
                                        className="btn-send"
                                        style={{ padding: "4px 25px" }}
                                        onClick={() => this.sendResiliationForm()}
                                    />
                                </div>
                            }
                        </div>
                    </div >
                }
                {
                    this.state.successSend &&
                    <TemplateResiliationSuccess></TemplateResiliationSuccess>
                }
            </div>
        );
    }
}
const mapStateToProps = state => ({
    user: state.auth.user
});
const mapDispatchToProps = dispatch => {
    return {
        dispatch: action => {
            dispatch(action);
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Resiliation);
